<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('autoHistory.title') }} - {{ autoTitle }}
          </h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <!-- Auto history table -->
          <v-layout wrap align-center>
            <v-flex xs12 v-if="!dataIsLoading">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
              >
                <template #[`item.result`]="{ item }">
                  <div v-html="item.result" />
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import store from '@/store';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    const isInvestor = store.getters['global/getRole'] === 'investor';
    if (!isInvestor || hasPermission('investor_car_rent_rate_history')) next();
  },
  data: () => ({
    dataIsLoading: false,
  }),
  computed: {
    autoTitle() {
      return this.$store.getters['auto/getAutoTitle'];
    },
    headers() {
      return [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('autoHistory.tableHeaders.date'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('rates.date'),
          value: 'start_date',
          sortable: false,
        },
        {
          text: this.$t('common.fields.email'),
          value: 'email',
          sortable: false,
        },
        {
          text: this.$t('autoHistory.tableHeaders.action'),
          value: 'key',
          sortable: false,
        },
        {
          text: this.$t('common.table.description'),
          value: 'result',
          sortable: false,
        },
      ];
    },
    items() {
      return this.$store.state.auto.autoRatesData;
    },
  },
  async created() {
    this.dataIsLoading = true;
    await this.$store.dispatch(
      'auto/fetchAutoRates',
      this.$route.params.autoId,
    );
    this.dataIsLoading = false;
  },
};
</script>

<style></style>
